<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
  >
    <g transform="translate(18087 15297)">
      <g transform="translate(-18086.1 -15295.2)">
        <path
          d="M9.125,18.3h-5.5A.624.624,0,0,1,3,17.675V7.5H18.525a.675.675,0,0,1,.675.675v.338"
          transform="translate(-3 -4.462)"
          fill="none"
          :stroke="props.colorFill"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          :style="{ fill: 'none !important' }"
        />
        <path
          d="M8.6,4.353l2.5,2.81H3V4.8a.675.675,0,0,1,.675-.675H8.1a.675.675,0,0,1,.507.228Z"
          transform="translate(-3 -4.125)"
          fill="none"
          :stroke="props.colorFill"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          :style="{ fill: 'none !important' }"
        />
        <path
          d="M8.268,6.728H6.683a.35.35,0,1,0,0,.7h.84A2.8,2.8,0,0,1,2.7,5.5a.35.35,0,0,0-.7,0A3.5,3.5,0,0,0,7.908,8.03v.62a.35.35,0,0,0,.7,0V7.075A.35.35,0,0,0,8.268,6.728ZM5.5,2a3.5,3.5,0,0,0-2.408.969V2.35a.35.35,0,1,0-.7,0V3.925a.35.35,0,0,0,.35.35H4.317a.35.35,0,0,0,0-.7h-.84A2.8,2.8,0,0,1,8.3,5.5a.35.35,0,0,0,.7,0A3.5,3.5,0,0,0,5.5,2Z"
          transform="translate(7.199 4.837)"
          :fill="props.colorFill"
          :stroke="props.colorFill"
          stroke-width="0.2"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconRecover',

  props: {
    size: { type: [String, Number], default: '16px' },
    colorFill: { type: String, default: '#d6001b' },
  }
}
</script>